import { parseJwt, getCookie, redirectAdmin, getUserByUrl, redirectOperator, withOutLoginUrl, withOutAdminLoginUrl } from "BridgeFunction";
import { getloginDetail } from "Constant/apiConstant";
import { checkLoginUser } from "rental-operator/redux/Actions/OperatorLoginAction";
import { request } from "utils/request";

export const checkTokenExpirationMiddleware = store => next => action => {
  if ((getUserByUrl() == 'admin' || getUserByUrl() == 'tour-admin') && withOutAdminLoginUrl() && getCookie(process.env.REACT_APP_ADMIN_DEV_COOKIE)) {
    const token = parseJwt(getCookie(process.env.REACT_APP_ADMIN_DEV_COOKIE))
    // console.log(token.exp, (Date.now() / 1000))
    if (token.exp < Date.now() / 1000) {
      localStorage.clear();
      redirectAdmin()
      next(action);
    }
  }
  if ((getUserByUrl() == 'partner' || getUserByUrl() == "tour-partner") && withOutLoginUrl() && getCookie(process.env.REACT_APP_OPERATOR_DEV_COOKIE)) {
    const token = parseJwt(getCookie(process.env.REACT_APP_OPERATOR_DEV_COOKIE))
    // console.log(token.exp, (Date.now() / 1000))
    if (token.exp < Date.now() / 1000) {
      localStorage.clear();
      redirectOperator()
      next(action);
    }
  }

  return next(action);
};